import {
    GET_CURRENT_USER_REQUEST,
    GET_CURRENT_USER_SUCCESS,
    GET_CURRENT_USER_FAILURE,
} from "../actions/actionTypes";

const initState = {
    isFetching: false,
    userId: null,
    organizationId: null,
    userName: null,
    firstName: null,
    lastName: null,
    active: null,
};

const currentUserReducer = (state = initState, action) => {
    switch (action.type) {
        case GET_CURRENT_USER_REQUEST:
            return Object.assign({}, state, {
                isFetching: true,
            });
        case GET_CURRENT_USER_SUCCESS:
            return Object.assign({
                isFetching: false,
                userId: action.response.userId,
                organizationId: action.response.organizationId,
                userName: action.response.userName,
                firstName: action.response.firstName,
                lastName: action.response.lastName,
                active: action.response.active,
            });
        case GET_CURRENT_USER_FAILURE:
            return Object.assign({
                isFetching: false,
                userId: null,
                organizationId: null,
                userName: null,
                firstName: null,
                lastName: null,
                active: false,
            });
        default:
            return state;
    }
};

export default currentUserReducer;
